import React from 'react';
import { Col, Form, Input, Row, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { selectMarcoArea, selectYears } from '../../../../../contants';

const InfoSection = ({ shoppingCenters }) => {
  const { t } = useTranslation();
  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Informazioni Generali')}</Typography.Title>
      </Col>
      <Col span={9}>
        <Form.Item
          label={t('Titolo')}
          name='title'
        // rules={[
        //   {
        //     required: true,
        //   },
        // ]}
        >
          <Input placeholder={t('Inserisci testo')} />
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Outlet Village')} name='shopping_center_id'>
          <Select placeholder={t('Selezioni opzione')}>
            <Select.Option value={''}>{t('Selezioni opzione')}</Select.Option>
            {shoppingCenters.map((i) => (
              <Select.Option value={i.id} key={i.id}>
                {i.title}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col offset={6} span={9}>
        <Form.Item label={t('Macro-Area')} name='macro_area'>
          <Select placeholder={t('Selezioni opzione')}>
            <Select.Option value={''}>{t('Selezioni opzione')}</Select.Option>
            {selectMarcoArea.map((i) => (
              <Select.Option key={i} value={i}>
                {i}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={9}>
        <Form.Item label={t('Anno Edizione')} name='year'>
          <Select placeholder={t('Selezioni opzione')}>
            <Select.Option value={''}>{t('Selezioni opzione')}</Select.Option>
            {selectYears.map((i) => (
              <Select.Option key={i} value={i}>
                {i}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(InfoSection);
